// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1Ew0B","label":"Category_label__3tmz1","content":"Category_content__2I8bB","header":"Category_header__G9upI","location":"Category_location__3uOBb"};